<template>
    <div class="row">
        <div class="col col-12 col-md-3">
            Valor Pago Online: R$ {{ $util.formatMoeda(pagamento.js_resposta.Payment.Amount / 100) }}
        </div>
        <div class="col col-12 col-md-3">
            Tipo: {{ pagamento.js_resposta.Payment.Type }}
        </div>
        <div class="col col-12 col-md-3">
            NSU: {{ pagamento.js_resposta.Payment.ProofOfSale }}
        </div>
        <div class="col col-12 col-md-3" v-if="pagamento.js_resposta.Payment.CreditCard">
            Cartão: 
                {{ pagamento.js_resposta.Payment.CreditCard.CardNumber }}
                {{ pagamento.js_resposta.Payment.CreditCard.Brand }}
        </div>
        <pre v-if="false">{{ pagamento }}</pre>
    </div>
</template>

<script>
export default {
    props: ['pagamento'],    
}
</script>


